export default function ProfileShow() {
  return <div></div>;
}
